import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { AuthService } from '../auth/auth.service';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [FormsModule, NgClass],
})
export class LoginComponent {
  credentials = { email: 'admin@example.com', password: 'admin' };

  protected error?: string = undefined;
  protected loggingIn = false;
  protected showPassword = false;
  protected rememberMe = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  login() {
    this.error = undefined;
    this.authService.getCsrfCookie().subscribe({
      next: (csrf) => {
        this.authService.login(this.credentials).subscribe({
          next: (response) => {
            this.router.navigate(['/dashboard']);
          },
          error: (response) => {
            this.error = response.error.message;
          },
        });
      },
    });
  }

  protected readonly environment = environment;
}
